import { default as animation1Alwhe9iBAMeta } from "/home/forge/client-solarrechner.der-solarteur.com/pages/animation.vue?macro=true";
import { default as consumersnzTBxdR07qMeta } from "/home/forge/client-solarrechner.der-solarteur.com/pages/consumers.vue?macro=true";
import { default as consumptiontX4u4W6MTCMeta } from "/home/forge/client-solarrechner.der-solarteur.com/pages/consumption.vue?macro=true";
import { default as contactt5wrEgmjZJMeta } from "/home/forge/client-solarrechner.der-solarteur.com/pages/contact.vue?macro=true";
import { default as indexbTu3MzZN4AMeta } from "/home/forge/client-solarrechner.der-solarteur.com/pages/index.vue?macro=true";
import { default as reportisD6gBB3AXMeta } from "/home/forge/client-solarrechner.der-solarteur.com/pages/report.vue?macro=true";
import { default as typeDheYMKgyQeMeta } from "/home/forge/client-solarrechner.der-solarteur.com/pages/type.vue?macro=true";
export default [
  {
    name: "animation",
    path: "/animation",
    component: () => import("/home/forge/client-solarrechner.der-solarteur.com/pages/animation.vue").then(m => m.default || m)
  },
  {
    name: "consumers",
    path: "/consumers",
    component: () => import("/home/forge/client-solarrechner.der-solarteur.com/pages/consumers.vue").then(m => m.default || m)
  },
  {
    name: "consumption",
    path: "/consumption",
    component: () => import("/home/forge/client-solarrechner.der-solarteur.com/pages/consumption.vue").then(m => m.default || m)
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/home/forge/client-solarrechner.der-solarteur.com/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/forge/client-solarrechner.der-solarteur.com/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "report",
    path: "/report",
    component: () => import("/home/forge/client-solarrechner.der-solarteur.com/pages/report.vue").then(m => m.default || m)
  },
  {
    name: "type",
    path: "/type",
    component: () => import("/home/forge/client-solarrechner.der-solarteur.com/pages/type.vue").then(m => m.default || m)
  }
]